// extracted by mini-css-extract-plugin
export default {"wrap":"FCMMessage_wrap__WIyhF","topWrap":"FCMMessage_topWrap__7SwUl"};